import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../components/common/layout/header";
import Footer from "../../components/common/layout/footer";
import Loader from "../../components/common/loader";
import { useSelector, useDispatch } from "react-redux";
import { userLogin } from "./usersSlice";
import { setStorage, getStorage } from "../../components/utilityfunctions";
import { useTranslation, Trans } from "react-i18next";
import parse from 'html-react-parser';

const Login = () => {

  const [password, setPassword] = useState("");
  const [account, setAccount] = useState("");
  const [keepmesignedin, setKeepmesignedin] = useState(false);
  const [loginStatus, setLoginStatus] = useState("");
  const [loginMessage, setLoginMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [validationErrors, setValidationErrors] = useState({
    account: "",
    password: "",
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation(); // Used Translation file
  const { userData, status, error } = useSelector((state) => state.users);
  useEffect(() => {
    if (!error && status === "succeeded") {
      setIsLoading(false);

      if (userData.hasOwnProperty("data")) {
        if (userData.data.status === 200) {
          const loginDetails = userData.data;
          setStorage("isLoggedIn", true);
          setStorage("priceband", loginDetails.accountPriceListId);
          setStorage("authData", JSON.stringify(loginDetails));
          setStorage("accountCode", loginDetails.accountCode);
          setStorage("uuid", loginDetails.uuid);
          setStorage(
            "accountDeliverableDays",
            loginDetails.accountDeliverableDays
          );
          setStorage("token", loginDetails.token);
          localStorage.removeItem("isAvailThisOffer");
          localStorage.removeItem("availedOffer");
          navigate("/home");
        } else {
          setLoginStatus(401);
          setLoginMessage(userData.data.message);
        }
      } else {
        setLoginMessage(userData.data.message);
        setLoginStatus(userData.data.status);
      }
    }
  }, [navigate, userData, status, error]);

  useEffect(() => {
    if (getStorage("isLoggedIn")) {
      navigate("/home");
    }

    const cookieChecked = getStorage("cookie_accepted");
    if (!cookieChecked) {
      document.body.classList.add("cookies-on");
    }
  }, [navigate]);



  const handleInputChange = (e) => {
    const { name, value } = e.target; // Destructure name and value from the event target

    if (name === "account") {
      const alphanumericRegex = /^[a-zA-Z0-9 ]*$/;
      if (alphanumericRegex.test(value)) {
        // Check for spaces in the middle (if spaces are allowed, they should only be at the start or end)
        const trimmedValue = value.replace(/\s+(?=\S)/g, '');
        setAccount(trimmedValue);
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          account: "",
        }));

      }
    } else if (name === "password") {
      setPassword(value);

      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        password: "",
      }));

    } else if (name === 'keepmesignedin') {

      setKeepmesignedin(!keepmesignedin);
    }


    setLoginStatus("");
    setLoginMessage("");
  };

  const formvalidation = () => {
    let isValid = true;
    // Perform validation before submission
    if (account.trim().length < 5) {
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        account: `${t('account_code_errmsg_txt')}`,
      }));
      isValid = false;
    }

    if (password.length < 6) {
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        password: `${t('password_errmsg_txt')}`,
      }));
      isValid = false;
    }


    return isValid;
  }

  const loginOnSubmit = async (event) => {
    event.preventDefault();

    const isValid = formvalidation();
    if (isValid) {
      let payload = {
        account: account.trim(),
        password: password,
        keepMeSignedIn: keepmesignedin,
      };
      setIsLoading(true);
      try {
        dispatch(userLogin(payload));
      } catch (error) {
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <Header />
      {!getStorage("isLoggedIn") && !isLoading && (
        <main className="main-section">
          <div className="login">
            <div className="form">
              <form className="login-form" onSubmit={loginOnSubmit}>
                <h2>{t('Login_txt')}</h2>

                <div className="form-field input-field">
                  {loginStatus ? (
                    loginStatus === 401 ? (
                      <p className="err-msg">{parse(loginMessage)}</p>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  <input
                    type="text"
                    id="accountCode"
                    name="account"
                    value={account}
                    placeholder={t('acc_code')}
                    required
                    onChange={(e) => handleInputChange(e)}
                  />
                  {validationErrors.account && (
                    <p className="error-msg">{validationErrors.account}</p>
                  )}
                </div>

                <div className="form-field input-field">
                  <input
                    type="password"
                    id="accountPassword"
                    name="password"
                    value={password}
                    placeholder={t('acc_password')}
                    required
                    onChange={(e) => handleInputChange(e)}
                  />
                  {validationErrors.password && (
                    <p className="error-msg">{validationErrors.password}</p>
                  )}
                </div>
                <div className="check-box">
                  <input
                    type="checkbox"
                    className="checkbox"
                    id="chkbox"
                    name="keepmesignedin"
                    onChange={(e) => handleInputChange(e)}
                  />
                  <label htmlFor="chkbox">
                    {t('keepmesignedin')}
                  </label>
                  <span className="disclaimer-info" onClick={() =>
                    setVisibleAlert(true)
                  }><i className="fa fa-exclamation-circle"></i></span>
                </div>

                <button type="submit">{t('Login_txt')}</button>
              </form>

              <div className="forget-pass-field">
                <Link className="pass-reset" to="/forgot-password">
                  {t('forget_password_txt')}
                </Link>
              </div>
            </div>

          </div>
        </main>
      )}
      {isLoading && (
        <main className="main-section">
          {" "}
          <Loader propsClassName="load-lag" />{" "}
        </main>
      )}

      {visibleAlert === true && (
        <div className="custom-alert-pop paylater-popup">
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <span className="close-alert" onClick={() => setVisibleAlert(false)}></span>
                <h4>Disclaimer</h4>
              </div>
              <div className="custom-alert-body">
                {/* <p>
                  {t('keepmesigned_disclaimertxt')}
                </p> */}
                <div className="disclaimer-note">
                  <Trans
                    i18nKey="keepmesigned_disclaimertxt"
                    components={{
                      p: <p />,
                      br: <br />,
                      strong: <strong />,
                      ul: <ul />,
                      li: <li />

                    }}
                  />

                </div>
                <div className="alert-buttons">
                  <a
                    title={t('ok_btntxt')}
                    onClick={() => setVisibleAlert(false)}
                    className="popup-alert-btn button"

                  >
                    {t('ok_btntxt')}
                  </a>

                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </>
  );
};

export default Login;
